/* eslint-disable react/prop-types */
import React from 'react'
import './style.css'
import Footerlog from './../../img/logofoot.png'
import Telegram from './../../img/Telegram App.png'
import VK from './../../img/VK com.png'
import BackToTopButton from '../../Helper/scroll/BackToTopButton'
import { NavLink } from 'react-router-dom'

const Footer = ({
  handleNavLinkClick
}) => {
  const emailAddress = 'info@freesunpro.com'

  return (
    <footer className="footer center-footer" id="footer">
      <div className="footer-box">
        <NavLink to="/">
          <img
            onClick={() => handleNavLinkClick('/')}
            className="fooret-img"
            src={Footerlog}
            alt=""
          />
        </NavLink>
        <div className="footer-info">
          <div className="footer-info-box">
            <NavLink
              to="/information-about-the-school"
              className="footer-info-txt"
            >
              О нас
            </NavLink>

            <p
              className="footer-info-txt"
              onClick={() => handleNavLinkClick('/', 'courses')}
            >
              Образовательная программа
            </p>

            <NavLink to="/Club-Free-Sun" className="footer-info-txt">
              Клуб Free Sun
            </NavLink>
            <NavLink to="/Gold-Bonus" className="footer-info-txt">
              Золотой бонус
            </NavLink>
            <a className="footer-info-txt" href="">
              Блог
            </a>
            <NavLink to="/News" className="footer-info-txt">
              Новости
            </NavLink>
          </div>
          <div className="footer-info-box">
            <a className="footer-info-txt" href="">
              Политика обработки персональных данных
            </a>
            <a className="footer-info-txt" href="">
              Публичная оферта
            </a>
            <NavLink
              className="footer-info-txt"
              to="/installment-loan-from-Tbank"
            >
              Способы оплаты
            </NavLink>
            {/* <a className="footer-info-txt" href="">
              Кредит на образование
            </a> */}
            <NavLink className="footer-info-txt" to="/License">
              Лицензия на осуществление образовательной деятельности
            </NavLink>
            <a className="footer-info-txt" href="">
              СМИ о нас
            </a>
          </div>
        </div>

        <div className="footer-info-num">
          <a className="footer-num" href="tel:+79315884966">
            +7 931 588 49 66
          </a>

          <a className="footer-num" href={`mailto:${emailAddress}`}>
            info@freesunpro.com
          </a>
          <h2 className="footer-num">Москва ул.Верхние Поля д. 10 пом. 113</h2>
          <div className="footer-icon">
            <a href="https://vk.com/freesunfilmschool">
              <img className="footer-icon-img" src={VK} alt="" />
            </a>
            <a href="https://t.me/freesunproschool">
              <img className="footer-icon-img" src={Telegram} alt="" />
            </a>
          </div>
        </div>
      </div>

      <div className="footer-log">
        <p className="footer-log-txt">2024 All rights reserved</p>
        <p className="footer-log-txt">FREE SUN FILM SCHOOL</p>
        <BackToTopButton />
      </div>
    </footer>
  )
}

export default Footer
